import React, { useEffect } from 'react';
import { validUser } from '../apis/auth';
import { useNavigate } from 'react-router-dom';

function Start() {
  const pageRoute = useNavigate();

  useEffect(() => {
    const isValid = async () => {
      const data = await validUser();
      if (!data?.user) {
        pageRoute('/login');
      } else {
        pageRoute('/chats');
      }
    };
    isValid();
  }, [pageRoute]);

  return (
    <div className="bg-[var(--bg-primary)] flex items-center justify-center flex-col gap-5 w-screen h-screen">

      {/* Animated logo */}
      <div
        className="w-20 h-20 rounded-3xl flex items-center justify-center animate-pulse-glow"
        style={{
          background: 'linear-gradient(135deg, #7C3AED 0%, #5B21B6 100%)',
          boxShadow: '0 0 40px rgba(124,58,237,0.5)',
        }}
      >
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
          <path
            d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2Z"
            fill="white"
            fillOpacity="0.95"
          />
          <circle cx="8" cy="10" r="1.5" fill="white" fillOpacity="0.5" />
          <circle cx="12" cy="10" r="1.5" fill="white" fillOpacity="0.5" />
          <circle cx="16" cy="10" r="1.5" fill="white" fillOpacity="0.5" />
        </svg>
      </div>

      <div className="flex flex-col items-center gap-1">
        <h1 className="text-xl font-bold text-[var(--text-primary)] tracking-tight">
          Endrohex <span className="gradient-text">Chat</span>
        </h1>
        <p className="text-sm text-[var(--text-muted)]">Loading your workspace…</p>
      </div>

      {/* Loading dots */}
      <div className="flex items-center gap-2 mt-2">
        <div className="typing-dot" style={{ animationDelay: '0s' }} />
        <div className="typing-dot" style={{ animationDelay: '0.2s' }} />
        <div className="typing-dot" style={{ animationDelay: '0.4s' }} />
      </div>
    </div>
  );
}

export default Start;